import { render, staticRenderFns } from "./watch.vue?vue&type=template&id=68a5caf2&scoped=true"
import script from "./watch.vue?vue&type=script&lang=js"
export * from "./watch.vue?vue&type=script&lang=js"
import style0 from "./watch.vue?vue&type=style&index=0&id=68a5caf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a5caf2",
  null
  
)

export default component.exports